// ABOUTME: Layout of the Scope and Actions steps: the form on the left, the recap column on the right, the footer below.
// ABOUTME: The sidebar and the footer are optional, so the rule edit page reuses the steps as plain panels.

import { Box, Stack, Typography } from '@ds/coolshop';
import { ReactNode } from 'react';

import { StepFooter } from './StepFooter';

/** The design system's three-view layout surface: the form column sits on it, the cards on white. */
export const FORM_SURFACE = '#F2F4F9';

type StepFrameProps = {
    title: string;
    subtitle: string;
    children: ReactNode;
    /** The recap column. */
    sidebar?: ReactNode;
    /** The step buttons, centred under both columns. */
    footer?: ReactNode;
};

export function StepFrame({ title, subtitle, children, sidebar, footer }: StepFrameProps) {
    return (
        <Stack flex={1} minHeight={0}>
            <Stack direction="row" flex={1} minHeight={0}>
                <Box flex={1} minWidth={0} overflow="auto" bgcolor={FORM_SURFACE}>
                    <Stack gap={3} p={3}>
                        <Stack gap={1}>
                            <Typography variant="subtitle1">
                                <Box component="span" fontWeight="bold">
                                    {title}
                                </Box>
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {subtitle}
                            </Typography>
                        </Stack>
                        {children}
                    </Stack>
                </Box>
                {sidebar && (
                    <Box
                        width={400}
                        flexShrink={0}
                        overflow="auto"
                        p={3}
                        borderLeft={1}
                        borderColor="divider"
                        bgcolor="background.paper"
                    >
                        {sidebar}
                    </Box>
                )}
            </Stack>
            {footer && <StepFooter>{footer}</StepFooter>}
        </Stack>
    );
}
